import styled from 'styled-components';

export const TableBodyRow = styled.tr`
  height: 30px;
  background: ${(props) => props.theme.tableRowColor};

  &:hover {
    background: ${(props) => props.theme.tableRowHover};
    cursor: pointer;
  }

  td {
    color: ${(props) => props.theme.tableRowFont};
    font-size: 14px;
    font-weight: 400;
    border-bottom: 1px solid ${(props) => props.theme.tableRowBorder};
    text-align: left;
    vertical-align: middle;
    padding-left: 10px;
  }
`;

export const TableBody = styled.tbody`
  width: 100%;
`;
